import React, { FC } from 'react'

import { Page, PageContent, Divider } from 'common'
import { MeanOfCommunicationBrSkeleton } from 'components/mean-of-communication-br-skeleton'
import { HeaderSkeleton } from 'components/header'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { TransactionalContainer } from '../styles/ProductBrSkeleton.styles'

export const ProductBrSkeleton: FC<{
  transactionalNotificationsSection?: {
    title: string
    details: string
  }
}> = ({ transactionalNotificationsSection }) => (
  <Page>
    <HeaderSkeleton />
    {transactionalNotificationsSection && (
      <TransactionalContainer>
        <Skeleton width="100%" height="4.6rem" />
      </TransactionalContainer>
    )}
    {transactionalNotificationsSection && <Divider $marginBottomPx={24} />}
    <PageContent
      padding={{
        top: transactionalNotificationsSection ? '0px' : '24px',
        left: '24px',
        right: '24px',
        bottom: '24px',
      }}
    >
      <Skeleton
        width="100%"
        height="4.3rem"
        style={{
          marginBottom: '1.5rem',
          marginTop: transactionalNotificationsSection ? '1.5rem' : '0rem',
        }}
      />

      <MeanOfCommunicationBrSkeleton />

      <Skeleton width="100%" height="0.8rem" />
      <Skeleton width="100%" height="0.8rem" style={{ marginTop: '0.1rem' }} />

      <Skeleton width="100%" height="4.3rem" style={{ marginTop: '1.5rem' }} />
    </PageContent>
  </Page>
)
